import { observer } from 'src/utils/mobx-react';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import Icon from 'src/components/Icon/Icon';
import {
    BetNameWrapper,
    InputAndBetNameWrapper,
    SingleBetName,
    SingleBetNameInfo,
} from 'src/components/BetSlip/SingleBet.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { DateTime } from 'src_common/utils/time/time';
import { SingleBetState } from 'src/components/BetSlip/SingleBet.state';
import { money } from 'src/utils/format';
import { autorun } from 'mobx';
import { TypeId } from 'src_common/common/websocket2/type';
import { FreeBetSelector, FreeBetType } from './BonusEngineFreeBets/FreeBetSelector';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { AvailableFreeBetType } from './BonusEngineFreeBets/FreeBetSelector.state';
export type SingleBetPropsType = {
    userId: number;
    bet: unknown;
    legs: unknown;
    currency: unknown;
    sportPriceLadders: unknown;
    // competitions: unknown - remove after betslip refactor if need
    assignedToMe: unknown;
    focusedBet: unknown;
    selected: unknown;
    betWasChanged: () => void;
    onSelect: () => void;
    onUnselect: () => void;
    onLegChange: (leg: unknown, values: unknown) => void;
    onChange: (params: unknown) => void;
    onRemove: () => void;
    onAddSplitBet: () => void;
    onRemoveSplitBet: () => void;
    onSetChangesStatus: (bet: unknown, status: string) => void;
    inPlacement: () => boolean;
    isOffered: boolean;
    bonusEngineFreeBets: Array<FreeBetType>;
    selectedFreeBets: Array<AvailableFreeBetType>;
    toggleFreeBet: (freeBet: AvailableFreeBetType) => void;
    clearFreeBetSelection: () => void;
};

export const SingleBet = observer('SingleBet', (propsIn: SingleBetPropsType) => {
    const appState = useAppStateContext();
    const props = useAsObservableSource(propsIn);
    const common = useCommon();
    const { config } = ConfigState.get(common);

    const [state] = useState(() => new SingleBetState(props, appState));
    const { selected, assignedToMe, bet, leg, currencySymbol, isSelectedLeg, currency, betBonusEngineFreeBets } = state;

    useEffect(() => {
        const dispose = autorun(() => {
            const betStake = state.bet?.stakePerLine;
            const currentStake = state.stakePerLine;
            if (betStake !== undefined && betStake !== null && betStake != '0' && betStake !== currentStake) {
                state.setStakePerLine(betStake.toString());
            }
        });

        return dispose;
    }, []);

    if (bet === null) {
        return null;
    }
    if (leg === null) {
        console.warn('LEG IS NULL OR UNDEFINED');
        return null;
    }

    if (leg.eventId === undefined || leg.marketId === undefined || leg.selectionId === undefined) {
        return null;
    }

    const hasSP = leg.priceType === 'sp';
    const possibleReturnsEstimated = !hasSP && bet.potentialReturnsAt !== Math.round(state.betStake * 100);
    const possibleReturns = hasSP ? null : bet.potentialReturns;
    const isReferred = bet.isReferred ?? false;

    const marketId = TypeId.newMarketId(leg.eventId, leg.marketId);
    const selectionModel = appState.sdkStaff.models.getSelectionAndLoad(marketId, leg.selectionId);
    const marketModel = appState.sdkStaff.models.getMarket(marketId);
    const eventModel = appState.sdkStaff.models.getEvent(leg.eventId);

    if (eventModel === null) {
        console.log('Single bet - event model is null', eventModel);
        return null;
    }

    const eventTimeFormatted = DateTime.from(eventModel.timeSettingsStartTime)?.format('HH:mm DD/MM/YYYY') ?? '';
    const competitionName = appState.sdkStaff.models.getCompetitionModel(eventModel.competition2.toOldId())?.name ?? '';

    let spCheckbox;
    if (marketModel !== null && marketModel.sp) {
        spCheckbox = (
            <label className='checkbox'>
                <input
                    type='checkbox'
                    checked={leg.priceType === 'sp'}
                    onChange={state.toggleSP}
                    data-test='checkbox-sp-price'
                />{' '}
                SP
            </label>
        );
    }

    let priceChangedWarning;
    if (hasSP === false && state.priceWasChange === true) {
        priceChangedWarning = (
            <div className='betslip__price-change'>
                Price has changed.
                {
                    <span className='betslip__price-change--value'>
                        New price: <b> {selectionModel?.price?.f} </b>
                    </span>
                }
                {/*
                Maybe to remove maybe not 0.o
                <a href='#' onClick={ state.clearPriceChange }>&times;</a>
                */}
                {
                    <div>
                        <button onClick={state.onPriceAcceptHandler}>accept new price</button>
                        <button onClick={state.onPriceOverrideHandler}>keep betslip price</button>
                    </div>
                }
            </div>
        );
    }

    if (state.suspendedChange) {
        priceChangedWarning = <div className='betslip__price-change'>Selection is suspended.</div>;
    }

    const clsName = classNames({
        'betslip-leg--marked': isSelectedLeg,
        'is-sp': hasSP,
    });
    return (
        <li className={clsName}>
            {bet.isSplitted === true && (assignedToMe === true || !isReferred) ? (
                <a
                    href='#'
                    className='betslip-leg-remove'
                    onClick={state.onRemoveSplitBetHandler}
                >
                    &times;
                </a>
            ) : assignedToMe === true || !isReferred ? (
                <a
                    href='#'
                    className='betslip-leg-remove'
                    onClick={state.onRemoveHandler}
                >
                    &times;
                </a>
            ) : null}

            <div className='betslip-leg-amount single'>
                <div className='row'>
                    <div className='col-5'>
                        <div className={classNames(['element', { 'bet-red-border': state.suspendedChange }])}>
                            <input
                                type='text'
                                readOnly={hasSP}
                                style={state.suspendedChange ? { color: 'red' } : undefined}
                                value={hasSP ? 'SP' : state.getPrice}
                                onChange={state.onUpdatePriceHandler}
                                onBlur={state.onSavePriceHandler}
                                data-test='single-stake-price'
                            />
                            {state.getPrice !== 'SP' &&
                            state.priceFromSportPriceLadders !== null &&
                            state.priceFromSportPriceLadders.length > 0 ? (
                                <div className='betslip-spinner'>
                                    <div onClick={state.getNextPriceFromLadder}>
                                        <Icon name='up' />
                                    </div>
                                    <div onClick={state.getPrevPriceFromLadder}>
                                        <Icon name='down' />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className='col-7'>
                        <div className='element'>
                            <span className='prefix'>{currencySymbol}</span>
                            <input
                                type='text'
                                value={state.getStakePerLine}
                                onChange={state.onChangeStakePerLine}
                                onBlur={state.saveStake}
                                onFocus={state.cleanStake}
                                data-test='single-stake-input'
                            />
                        </div>
                    </div>
                </div>
                {betBonusEngineFreeBets.some((fb) => fb.freeBets.length > 0) && config.showBonusEngine === true && (
                    <FreeBetSelector
                        betUid={bet.uid}
                        betType={bet.type}
                        userId={props.userId}
                        bonusEngineFreeBets={betBonusEngineFreeBets}
                        currency={typeof currency === 'string' ? currency : ''}
                        currencySymbol={currencySymbol}
                        selectedFreeBets={props.selectedFreeBets}
                        toggleFreeBet={props.toggleFreeBet}
                        clearFreeBetSelection={props.clearFreeBetSelection}
                    />
                )}
            </div>

            <BetNameWrapper>
                <InputAndBetNameWrapper>
                    <input
                        type='checkbox'
                        onChange={state.toggle}
                        checked={selected}
                    />
                    <SingleBetName>{selectionModel?.name ?? ''}</SingleBetName>
                </InputAndBetNameWrapper>

                <SingleBetNameInfo>
                    {marketModel?.name ?? ''}
                    <br />
                    {eventModel.name}
                    <br />
                    {competitionName}
                    <br />
                    {eventTimeFormatted}
                </SingleBetNameInfo>
            </BetNameWrapper>

            <div
                className={classNames([
                    'betslip-leg-returns',
                    { 'betslip-leg-returns--estimated': possibleReturnsEstimated },
                ])}
            >
                {possibleReturns !== null && possibleReturns !== undefined ? (
                    <div>Possible returns: {money(possibleReturns, currency)}</div>
                ) : null}
                {bet.maxStake !== null && bet.maxStake !== undefined ? (
                    <div className='betslip-leg-maxstake'>Cust. max bet: {money(bet.maxStake, currency)}</div>
                ) : null}
                {(bet.isSplitted === undefined || bet.isSplitted === false) &&
                bet.isReferred === true &&
                props.isOffered === false ? (
                    <button
                        className='btn btn--split-bet'
                        onClick={state.onAddSplitBetHandler}
                    >
                        Split bet
                    </button>
                ) : null}
            </div>

            <div className='betslip-leg-options'>
                {marketModel?.eachWay?.offered !== undefined &&
                marketModel.eachWay.offered === true &&
                selectionModel?.name !== 'Unnamed favourite' ? (
                    <label className='checkbox'>
                        <input
                            type='checkbox'
                            checked={state.betEw}
                            onChange={state.toggleEachWay}
                            data-test='checkbox-each-way'
                        />{' '}
                        EW
                    </label>
                ) : null}
                {spCheckbox}
            </div>

            {priceChangedWarning}
        </li>
    );
});
